<template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-travel">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-dest-nav></portal-dest-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation" v-show="['food'].indexOf($route.params._field)>-1">
                <span>首页</span>
                <span>></span>
                <span>文化旅游</span>
                <span>></span>
                <span>{{title[$route.params._field]}}</span>
              </div>
              <!-- 地区选择 -->
              <!-- <bs-list
                :filter="filter"
                :meta="{ module:'common-area',field:'destArea' }"
                :is-loading="true"
                 v-if="['food'].indexOf($route.params._field)>-1"
              >
              <template slot="data" slot-scope="slot">-->
              <div class="head-select" v-if="['food'].indexOf($route.params._field)>-1">
                <el-row :gutter="10">
                  <el-col :span="24">
                    <div class="grid-content bg-purple">
                      <span class="address">地区选择:</span>
                      <ul>
                        <li
                          v-bind:class="{'selected': selectedAreaCode==''}"
                          v-on:click="selectArea('')"
                        >
                          <a class="font-size">不限</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '延平'}"
                          v-on:click="selectArea('延平')"
                        >
                          <a class="font-size">延平</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '建阳'}"
                          v-on:click="selectArea('建阳')"
                        >
                          <a class="font-size">建阳</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '顺昌'}"
                          v-on:click="selectArea('顺昌')"
                        >
                          <a class="font-size">顺昌</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '浦城'}"
                          v-on:click="selectArea('浦城')"
                        >
                          <a class="font-size">浦城</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '光泽'}"
                          v-on:click="selectArea('光泽')"
                        >
                          <a class="font-size">光泽</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '松溪'}"
                          v-on:click="selectArea('松溪')"
                        >
                          <a class="font-size">松溪</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '政和'}"
                          v-on:click="selectArea('政和')"
                        >
                          <a class="font-size">政和</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '邵武'}"
                          v-on:click="selectArea('邵武')"
                        >
                          <a class="font-size">邵武</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '武夷山'}"
                          v-on:click="selectArea('武夷山')"
                        >
                          <a class="font-size">武夷山</a>
                        </li>
                        <li
                          v-bind:class="{'selected':  selectedAreaCode  == '建瓯'}"
                          v-on:click="selectArea('建瓯')"
                        >
                          <a class="font-size">建瓯</a>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <!-- </template>
              </bs-list>-->
              <div class="container">
                <el-row :gutter="20">
                  <!-- 美食餐饮 -->
                  <bs-page
                    :filter="filter"
                    :meta="meta"
                    ref="refId"
                    content-class
                    v-if="['food'].indexOf($route.params._field)>-1"
                  >
                    <template slot="data" slot-scope="slot">
                      <el-col
                        :span="6"
                        v-for="item in slot.data"
                        :key="item.mercId"
                        @click="handleDetail(item)"
                        class="list-wrap"
                      >
                        <div @click="handleDetail(item)" class="item" style="cursor:pointer">
                          <img
                            :src="item.imgUrl||$app.nodata.img"
                            :alt="item.mercName"
                            class="img-fluid"
                          />
                          <h5 class="title" v-text="item.mercName"></h5>
                        </div>
                        <div class="bottom">&nbsp;</div>
                      </el-col>
                    </template>
                    <template slot="empty">
                      <div>
                        <img src="../../assets/portal/zwsj.png" style="width:100%;height:300px" />
                      </div>
                    </template>
                    <template slot="paging" slot-scope="slot">
                      <el-pagination
                        style="float:clear; clear:both;margin:0 auto;text-align: center"
                        layout="prev, pager, next"
                        v-if="slot.data.totalCount>20"
                        background
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="filter.pageIndex"
                        :page-size="filter.pageSize"
                        :total="slot.data.totalCount"
                      ></el-pagination>
                    </template>
                  </bs-page>
                  <!-- 酒店住宿 -->
                  <div
                    content-class
                    v-else
                    style="position: absolute;left: -20px;right: 0;top: -20px;bottom: 0;height:880px;"
                  >
                    <iframe
                      src="http://zzwh-hotel.whlyw.net/Hotel/MoreHotel"
                      width="100%"
                      height="100%"
                      frameborder="0"
                      id="frame"
                      name="mainweb"
                      style="position:absolute;left:0;top:-10px;right:0;bottom:0"
                    ></iframe>

                    <!-- <template slot="data" slot-scope="slot"> -->
                    <!-- <el-col
                        :span="6"
                        v-for="item in slot.data"
                        :key="item.hotelIdField"
                        @click="handleHotelDetail(item)"
                        class="list-wrap"
                      >
                        <div @click="handleHotelDetail(item)" class="item" style="cursor:pointer">
                          <img
                            :src="item.detailField.thumbNailUrlField||$app.nodata.img"
                            :alt="item.detailField.hotelNameField"
                            class="img-fluid"
                          />
                          <h5 class="title" v-text="item.detailField.hotelNameField"></h5>
                        </div>
                        <div class="bottom">&nbsp;</div>
                    </el-col>-->
                    <!-- </template> -->
                    <!-- <template slot="empty">
                      <div>
                        <img src="../../assets/portal/zwsj.png" style="width:100%;height:300px" />
                      </div>
                    </template>
                    <template slot="paging" slot-scope="slot">
                      <el-pagination
                        style="float:clear; clear:both;margin:0 auto;text-align: center"
                        layout="prev, pager, next"
                        v-if="slot.data.totalCount>20"
                        background
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="filter.pageIndex"
                        :page-size="filter.pageSize"
                        :total="slot.data.totalCount"
                      ></el-pagination>
                    </template>-->
                  </div>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>
<script>
require("../../styles/portal/travel.scss");
export default {
  data() {
    return {
      title: {
        hotel: "酒店住宿",
        food: "餐饮美食"
      },
      selectedAreaCode: "",
      routeType: "merc",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 20,
        address: "",
        arrivalDateField: "",
        departureDateField: ""
      },
      api: null
    };
  },
  mounted() {
    var now = new Date();
    var startTime =
      now.getFullYear() +
      "-" +
      (now.getMonth() + 1 < 10 ? "0" : "") +
      (now.getMonth() + 1) +
      "-" +
      (now.getDate() < 10 ? "0" : "") +
      now.getDate();
    var date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
    var timeafter =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    this.filter.arrivalDateField = startTime;
    this.filter.departureDateField = timeafter;
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsPage: () => import("../../components/bs-page"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNavLeft: () => import("./portal-nav-left"),
    PortalDestNav: () => import("./portal-dest-nav"),
    PortalFooter: () => import("./portal-footer"),
    BsElHotelPage: () => import("../../components/bs-el-hotel-page"),
    BsList: () => import("../../components/bs-list")
  },
  methods: {
    selectArea: function(item) {
      //  debugger
      this.selectedAreaCode = item;
      this.filter.address = item;
      this.$refs["refId"].loadData();
      this.filter.pageIndex = 1;
    },
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/merc/detail/${_module}/${_field}_detail/${item.mercId}`
      });
    },
    handleHotelDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/merc/detail/${_module}/${_field}_detail/${item.hotelIdField}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    }
  },
  created() {
    this.$menuFn.setTitle(
      this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
    );
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-merc-page") {
        this.$menuFn.setTitle(
          this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
        );
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "portal"
      );
      if (this.routeWatch && contains && this.$route.params._field === "food") {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.pageIndex = 1;
        this.$refs["refId"].loadData();
        //  this.handleChangeData();
      }
    }
  }
};
</script>
<style lange="scss" scoped>
.head-select {
  /* height: 110px; */
}
.address {
  float: left;
  font-size: 16px;
}
ul {
  list-style: none;
  margin-top: -28px;
  margin-left: 40px;
  display: inline-block;
}

li {
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  cursor: pointer;
  overflow: hidden;
  font-size: 16px;
  margin-right: 5px;
  margin: 5px;
}
ul li.selected {
  background-color: #ecb700;
  color: #fff;
}
ul li:hover {
  background-color: #ecb700;
  color: #fff;
}
ul li:active {
  background-color: #ecb700;
  color: #fff;
}
.font-size {
  font-size: 16px;
}
.el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 60%;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 250px;
  margin-left: 20px;
}

.el-button--small {
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 20px;
}
.content-page {
  position: relative;
}
</style>